import useAirlineFilterManager from '@/src/hooks/srp/airlineFilterManager'
import { DeviceType } from '@/src/types/deviceType'
import { useMemo } from 'react'
import AirlineFilter from './airlineFilter'

interface AirlineFilterWrapperTopBarProps {
    showArrows?: boolean
    deviceType: DeviceType
}

const AirlineFilterWrapperTopBar = ({ showArrows = true, deviceType }: AirlineFilterWrapperTopBarProps) => {
    const { airlines, handleSelectToggle } = useAirlineFilterManager()
    const priceSortedAirlines = useMemo(() => {
        return airlines?.sort((a, b) => {
            return Number(a.unFormattedPrice) - Number(b.unFormattedPrice)
        })
    }, [airlines])

    return (
        <AirlineFilter
            airlines={priceSortedAirlines}
            onSelect={id => handleSelectToggle(id, 'FilterWrapperTopBar')}
            deviceType={deviceType}
            showArrows={showArrows}
        />
    )
}

export default AirlineFilterWrapperTopBar
